import React from "react";
import AddToolTip from "../AddToolTip/AddToolTip";

const FeeProrataCard = ({ name }) => {
  return (
    <div className="prorataCard">
      <AddToolTip
        name={name}
        className="prorataCardToolTip ft-14 fw-400"
        placement="top-start"
      />
    </div>
  );
};

export default FeeProrataCard;
